(function () {
  function getRoot() { return document.querySelector('[data-mb-searchd-root]'); }

  function open() {
    var root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    document.body.classList.add('mb-searchd-lock');
    var input = root.querySelector('[data-mb-searchd-input]');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }

  function close() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    document.body.classList.remove('mb-searchd-lock');
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlight(text, query) {
    var safe = escapeHtml(text);
    if (!query) return safe;
    var idx = safe.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return safe;
    return safe.slice(0, idx) + '<b>' + safe.slice(idx, idx + query.length) + '</b>' + safe.slice(idx + query.length);
  }

  // Shopify's /search/suggest.json returns product prices as a plain
  // decimal string (e.g. "34.95"), no currency symbol -- format it the
  // same way assets/mecca-cart-drawer.js's correctShippingBars() reads
  // the active currency, so a visitor in any Shopify Markets currency
  // sees a properly formatted amount instead of a bare number.
  function formatMoney(rawPrice) {
    var amount = parseFloat(rawPrice);
    if (isNaN(amount)) return '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function renderResults(root, query, data) {
    var body = root.querySelector('[data-mb-searchd-results]');
    var empty = root.querySelector('[data-mb-searchd-empty]');
    if (!body) return;

    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];

    if (!products.length && !articles.length) {
      body.innerHTML = '';
      body.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    body.hidden = false;

    var html = '';

    if (products.length) {
      html += '<div class="mb-searchd__grp"><div class="mb-searchd__gh">Books</div>';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var priceText = formatMoney(p.price);
        html +=
          '<a class="mb-searchd__res" href="' + p.url + '">' +
            '<span class="mb-searchd__lc">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="mb-searchd__i">' +
              '<span class="mb-searchd__t">' + highlight(p.title, query) + '</span>' +
              (p.vendor ? '<span class="mb-searchd__s">' + escapeHtml(p.vendor) + '</span>' : '') +
            '</span>' +
            (priceText ? '<span class="mb-searchd__pr">' + priceText + '</span>' : '') +
          '</a>';
      });
      html += '</div>';
    }

    if (articles.length) {
      html += '<div class="mb-searchd__grp"><div class="mb-searchd__gh">From the Reading Room</div>';
      articles.forEach(function (a) {
        html +=
          '<a class="mb-searchd__res" href="' + a.url + '">' +
            '<span class="mb-searchd__lc mb-searchd__lc--article">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>' +
            '</span>' +
            '<span class="mb-searchd__i">' +
              '<span class="mb-searchd__t">' + highlight(a.title, query) + '</span>' +
            '</span>' +
          '</a>';
      });
      html += '</div>';
    }

    html += '<a class="mb-searchd__seeall" href="/search?q=' + encodeURIComponent(query) + '&type=product">See all results for “' + escapeHtml(query) + '”</a>';

    body.innerHTML = html;
  }

  function initSearch() {
    var root = getRoot();
    if (!root) return;
    var input = root.querySelector('[data-mb-searchd-input]');
    var clearBtn = root.querySelector('[data-mb-searchd-clear]');
    var idle = root.querySelector('[data-mb-searchd-idle]');
    if (!input) return;

    var debounceTimer = null;

    function runSearch() {
      var query = input.value.trim();
      if (idle) idle.hidden = !!query;
      if (clearBtn) clearBtn.hidden = !query;

      if (debounceTimer) clearTimeout(debounceTimer);
      if (query.length < 2) {
        var body = root.querySelector('[data-mb-searchd-results]');
        var empty = root.querySelector('[data-mb-searchd-empty]');
        if (body) { body.innerHTML = ''; body.hidden = true; }
        if (empty) empty.hidden = true;
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type')
          .then(function (res) { return res.json(); })
          .then(function (data) { renderResults(root, query, data); })
          .catch(function () {});
      }, 200);
    }

    input.addEventListener('input', runSearch);

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        runSearch();
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mb-searchd-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-mb-searchd-close]')) {
      close();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = getRoot();
    if (root && root.classList.contains('is-open')) close();
  });

  document.addEventListener('DOMContentLoaded', initSearch);
})();
